import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User, UserRole } from '../../models/user';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  admin = new BehaviorSubject<User>(null);
  errors = new BehaviorSubject(null);
  token: string | null = null;
  private user: User;
  private userRequest$: Observable<User> | null = null;

  constructor(private http: HttpClient) {}

  getUser(token: string) {
    if (this.userRequest$ && this.token === token) {
      return this.userRequest$;
    }

    this.token = token;
    localStorage.setItem('token', this.token);
    const url = `${environment.API_BASE_URL}/v4/user/me`;

    this.userRequest$ = this.http
      .get(url, {
        params: new HttpParams().set('token', token),
      })
      .pipe(
        map((userData: User) => {
          this.setUserData(userData);
          if (userData.role === UserRole.ADMIN) {
            return userData;
          } else {
            throw new Error('Not an admin user');
          }
        }),
        catchError((err) => {
          this.userRequest$ = null;
          throw err;
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );

    return this.userRequest$;
  }

  private setUserData(data: User) {
    this.user = data;
  }

  getUserData() {
    return this.user;
  }

  logout() {
    this.token = null;
    this.user = null;
    this.userRequest$ = null;
    localStorage.removeItem('token');
  }
}
